"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var splide_1 = __importDefault(require("@splidejs/splide"));
var SplideSliderProductDetail = /** @class */ (function () {
    function SplideSliderProductDetail(selector) {
        this.sliders = document.querySelectorAll(selector);
        if (this.sliders.length < 1)
            return;
        // Configure slider defaults
        splide_1.default.defaults = {
            i18n: {
                prev: 'Previous slide',
                next: 'Next slide'
            }
        };
        // Configure each slider on the page
        this.sliders.forEach(function (element) {
            var splide = new splide_1.default(element, {
                perPage: 4,
                perMove: 1,
                rewind: false,
                gap: 0,
                breakpoints: {
                    768: {
                        perPage: 2,
                    }
                }
            });
            // Custom pagination
            splide.on('pagination:mounted', function (data) {
                data.items.forEach(function (item) {
                    item.button.textContent = String(item.page + 1 + ' / ' + (Math.ceil(splide.length / splide.options.perPage)));
                });
            });
            splide.mount();
        });
    }
    return SplideSliderProductDetail;
}());
exports.default = SplideSliderProductDetail;
